import React, { useContext } from 'react';
import ArticleBodyHelp from './ArticleBodyHelp';
import ArticleHelpful from './ArticleHelpful';
import { CustomerServiceContext } from './CustomerServiceContext';
import { IArticleResponse } from './ICustomerService';
import LeftChevron from './LeftChevron';
import useBreakpoint from '../utils/useBreakPoint';
import { useTranslation } from 'react-i18next';
import { en, fr } from './i18n';
import ArticleVideos from './ArticleVideos';

export interface ArticleBodyProps {
    article: IArticleResponse;
}

const ArticleBody = ({ article }: ArticleBodyProps) => {
    const { i18n, t } = useTranslation('customer-service');
    i18n.addResourceBundle('en', 'customer-service', en, true, true);
    i18n.addResourceBundle('fr', 'customer-service', fr, true, true);

    const { setView } = useContext(CustomerServiceContext);
    const { isMobile } = useBreakpoint();

    return (
        <>
            <div className="customer-service-faq__article__body">
                {isMobile && (
                    <button
                        className="customer-service-faq__article__body__nav"
                        onClick={() => {
                            setView('main');
                            window.history.pushState({}, '', '/pages/customer-service');
                        }}
                    >
                        <LeftChevron />
                        <span className="customer-service-faq__article__body__nav__back">{t('backToHelpCenter')}</span>
                    </button>
                )}

                <h1 className="customer-service-faq__article__body__title">{article.Article.Title}</h1>

                <article
                    dangerouslySetInnerHTML={{ __html: article.Article.Content.replace('container', '') }}
                    className="customer-service-faq__article__body__content"
                />

                <ArticleVideos article={article} />

                {/* <ArticleHelpful /> */}

                <ArticleBodyHelp />
            </div>
        </>
    );
};

export default ArticleBody;
